@if (message) {
	<div class="no-data-message">
		<svg width="282px" height="243px" viewBox="0 0 282 243" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<title>{{ message }}</title>
			<defs>
				<path
					d="M146.5,18.7793349 L142.482779,21 L143.25,16.2965558 L140,12.9655581 L144.49139,12.2793349 L146.5,8 L148.50861,12.2793349 L153,12.9655581 L149.75,16.2965558 L150.517221,21 L146.5,18.7793349 Z"
					id="path-1"
				></path>
				<mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="-2" y="-2" width="17" height="17">
					<rect x="138" y="6" width="17" height="17" fill="white"></rect>
					<use xlink:href="#path-1" fill="black"></use>
				</mask>
				<path
					d="M209,30.6334369 L206.527864,32 L207,29.1055728 L205,27.0557281 L207.763932,26.6334369 L209,24 L210.236068,26.6334369 L213,27.0557281 L211,29.1055728 L211.472136,32 L209,30.6334369 Z"
					id="path-3"
				></path>
				<mask id="mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="-2" y="-2" width="12" height="12">
					<rect x="203" y="22" width="12" height="12" fill="white"></rect>
					<use xlink:href="#path-3" fill="black"></use>
				</mask>
				<path
					d="M74,37.6334369 L71.527864,39 L72,36.1055728 L70,34.0557281 L72.763932,33.6334369 L74,31 L75.236068,33.6334369 L78,34.0557281 L76,36.1055728 L76.472136,39 L74,37.6334369 Z"
					id="path-5"
				></path>
				<mask id="mask-6" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="-2" y="-2" width="12" height="12">
					<rect x="68" y="29" width="12" height="12" fill="white"></rect>
					<use xlink:href="#path-5" fill="black"></use>
				</mask>
			</defs>
			<g id="Improvement-Plan" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="0.0.0_NoNewPlans" transform="translate(-579.000000, -210.000000)">
					<g id="Group-5" transform="translate(579.000000, 210.000000)">
						<circle id="Oval-2" fill="var(--nha-color-blue-300)" opacity="0.200000003" cx="141.5" cy="121.5" r="121.5"></circle>
						<g id="Group-4" transform="translate(0.000000, 26.000000)">
							<path
								d="M0.963758544,107.5 L32.0236783,107.5"
								id="Line-Copy-8"
								stroke="var(--nha-color-gray-200)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<path
								d="M249.963759,107.5 L281.023678,107.5"
								id="Line-Copy-11"
								stroke="var(--nha-color-gray-200)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<path
								d="M17.9926589,95.5 L35.0236783,95.5"
								id="Line-Copy-9"
								stroke="var(--nha-color-gray-200)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<path
								d="M251.992659,95.5 L269.023678,95.5"
								id="Line-Copy-12"
								stroke="var(--nha-color-gray-200)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<path
								d="M21.9926589,120.5 L39.0236783,120.5"
								id="Line-Copy-10"
								stroke="var(--nha-color-gray-200)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<path
								d="M244.992659,120.5 L262.023678,120.5"
								id="Line-Copy-13"
								stroke="var(--nha-color-gray-200)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<g
								id="Group-2"
								transform="translate(200.000000, 105.500000) rotate(10.000000) translate(-200.000000, -105.500000) translate(164.000000, 56.000000)"
								stroke-width="2"
							>
								<path
									d="M5,0 L66.2121228,-8.8817842e-16 C68.9735466,-1.39544373e-15 71.2121228,2.23857625 71.2121228,5 L71.2121228,93.6014008 C71.2121228,96.3628246 68.9735466,98.6014008 66.2121228,98.6014008 L5,98.6014008 C2.23857625,98.6014008 6.8079094e-15,96.3628246 -8.8817842e-16,93.6014008 L-8.8817842e-16,5 C-1.2263553e-15,2.23857625 2.23857625,-3.80913106e-16 5,-8.8817842e-16 Z"
									id="Rectangle-2-Copy"
									stroke="var(--nha-color-gray-400)"
									fill="var(--nha-color-white)"
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-dasharray="120,6,80,6"
								></path>
								<path
									d="M11.5,14.5 L56.5998891,14.5"
									id="Line"
									stroke="var(--nha-color-gray-200)"
									stroke-linecap="round"
									stroke-linejoin="round"
								></path>
								<path
									d="M27.5,23.5 L56.0394464,23.5"
									id="Line-Copy"
									stroke="var(--nha-color-gray-200)"
									stroke-linecap="round"
									stroke-linejoin="round"
								></path>
								<path
									d="M41.5,32.5 L56.0086181,32.5"
									id="Line-Copy-2"
									stroke="var(--nha-color-gray-200)"
									stroke-linecap="round"
									stroke-linejoin="round"
								></path>
								<circle id="Oval-Copy-2" stroke="var(--nha-color-gray-400)" fill="var(--nha-color-gray-50)" cx="25" cy="50" r="4"></circle>
								<circle id="Oval-Copy-3" stroke="var(--nha-color-gray-400)" fill="var(--nha-color-gray-50)" cx="46" cy="50" r="4"></circle>
								<path
									d="M16,66 C29.3170732,76.6666667 41.6829268,76.6666667 55,66"
									id="Path-2-Copy"
									stroke="var(--nha-color-gray-400)"
									stroke-linecap="round"
									stroke-linejoin="round"
								></path>
							</g>
							<g
								id="Group-3"
								transform="translate(83.000000, 105.500000) rotate(-10.000000) translate(-83.000000, -105.500000) translate(47.000000, 56.000000)"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							>
								<path
									d="M5,1.63424829e-13 L66.2121228,1.63424829e-13 C68.9735466,1.62917564e-13 71.2121228,2.23857625 71.2121228,5 L71.2121228,93.6014008 C71.2121228,96.3628246 68.9735466,98.6014008 66.2121228,98.6014008 L5,98.6014008 C2.23857625,98.6014008 -4.10271522e-15,96.3628246 -4.4408921e-15,93.6014008 L0,5 C-3.38176876e-16,2.23857625 2.23857625,1.63932095e-13 5,1.63424829e-13 Z"
									id="Rectangle-2-Copy-3"
									stroke="var(--nha-color-gray-400)"
									fill="var(--nha-color-white)"
									stroke-dasharray="70,6,150,6"
								></path>
								<path
									d="M20,48 C23.3292683,50.6666667 26.4207317,50.6666667 29.75,48"
									id="Path-2"
									stroke="var(--nha-color-gray-400)"
									transform="translate(24.875000, 49.000000) scale(1, -1) translate(-24.875000, -49.000000) "
								></path>
								<path
									d="M43,48 C46.3292683,50.6666667 49.4207317,50.6666667 52.75,48"
									id="Path-2-Copy-3"
									stroke="var(--nha-color-gray-400)"
									transform="translate(47.875000, 49.000000) scale(1, -1) translate(-47.875000, -49.000000) "
								></path>
								<path d="M11.5,14.5 L56.5998891,14.5" id="Line-Copy-5" stroke="var(--nha-color-gray-200)"></path>
								<path d="M11.5,23.5 L40.0394464,23.5" id="Line-Copy-6" stroke="var(--nha-color-gray-200)"></path>
								<path d="M11.5,32.5 L26.0086181,32.5" id="Line-Copy-7" stroke="var(--nha-color-gray-200)"></path>
								<path
									d="M16,66 C29.3170732,76.6666667 41.6829268,76.6666667 55,66"
									id="Path-2-Copy-2"
									stroke="var(--nha-color-gray-400)"
								></path>
							</g>
							<rect
								id="Rectangle-4"
								stroke="var(--nha-color-gray-200)"
								transform="translate(88.500000, 42.500000) rotate(45.000000) translate(-88.500000, -42.500000) "
								x="87.5"
								y="41.5"
								width="2"
								height="2"
								rx="1"
							></rect>
							<rect
								id="Rectangle-4"
								stroke="var(--nha-color-gray-200)"
								transform="translate(52.500000, 42.500000) rotate(45.000000) translate(-52.500000, -42.500000) "
								x="51.5"
								y="41.5"
								width="2"
								height="2"
								rx="1"
							></rect>
							<path
								d="M225.816455,19.6452323 C225.27104,19.6452323 224.828893,20.0873792 224.828893,20.6327949 C224.828893,21.1782107 225.27104,21.6203576 225.816455,21.6203576 L225.863059,21.6203576 C226.408475,21.6203576 226.850622,21.1782107 226.850622,20.6327949 C226.850622,20.0873792 226.408475,19.6452323 225.863059,19.6452323 L225.816455,19.6452323 Z M168.34233,33.6701071 C168.070767,33.6701071 167.850622,33.8902525 167.850622,34.1618155 C167.850622,34.4333786 168.070767,34.6535239 168.34233,34.6535239 L168.3734,34.6535239 C168.644963,34.6535239 168.865108,34.4333786 168.865108,34.1618155 C168.865108,33.8902525 168.644963,33.6701071 168.3734,33.6701071 L168.34233,33.6701071 Z"
								id="Rectangle-4"
								stroke="var(--nha-color-gray-200)"
								transform="translate(197.350622, 27.149378) rotate(45.000000) translate(-197.350622, -27.149378) "
							></path>
							<rect id="Path" fill="var(--nha-color-gray-200)" x="111" y="20" width="3" height="3" rx="1.5"></rect>
							<rect id="Path-Copy-3" fill="var(--nha-color-gray-200)" x="188" y="38" width="4" height="4" rx="2"></rect>
							<rect id="Path-Copy-4" fill="var(--nha-color-gray-200)" x="221" y="13" width="5" height="5" rx="2.5"></rect>
							<rect id="Path-Copy-5" fill="var(--nha-color-gray-200)" x="76" y="12" width="2" height="2" rx="1"></rect>
							<path
								d="M97,54.3259379 L103.983031,53.0735637 C106.544157,52.6142376 108.986451,54.3536237 109.438046,56.9585911 L123.927674,140.540028 C124.144655,141.791649 123.862592,143.015367 123.226869,144 L102,144 C99.2385763,144 97,141.761424 97,139 L97,54.3259379 Z"
								id="Combined-Shape"
								fill-opacity="0.200000018"
								fill="var(--nha-color-blue-300)"
								style="mix-blend-mode: multiply"
							></path>
							<path
								d="M158,54.3259379 L164.983031,53.0735637 C167.544157,52.6142376 169.986451,54.3536237 170.438046,56.9585911 L184.927674,140.540028 C185.144655,141.791649 184.862592,143.015367 184.226869,144 L163,144 C160.238576,144 158,141.761424 158,139 L158,54.3259379 Z"
								id="Combined-Shape-Copy"
								fill-opacity="0.200000018"
								fill="var(--nha-color-blue-300)"
								style="mix-blend-mode: multiply"
								transform="translate(171.500000, 98.500000) scale(-1, 1) translate(-171.500000, -98.500000) "
							></path>
							<path
								d="M107,33 L175,33 C177.761424,33 180,35.2385763 180,38 L180,136 C180,138.761424 177.761424,141 175,141 L107,141 C104.238576,141 102,138.761424 102,136 L102,38 C102,35.2385763 104.238576,33 107,33 Z"
								id="Rectangle-2"
								stroke="var(--nha-color-gray-400)"
								stroke-width="2"
								fill="var(--nha-color-white)"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-dasharray="120,6,80,6"
							></path>
							<g id="Group" transform="translate(122.000000, 87.000000)">
								<rect id="Rectangle-3" fill="var(--nha-color-gray-400)" x="24" y="3" width="14" height="2" rx="1"></rect>
								<circle
									id="Oval"
									stroke="var(--nha-color-gray-400)"
									stroke-width="2"
									fill="var(--nha-color-gray-50)"
									cx="4"
									cy="4"
									r="4"
								></circle>
							</g>
							<path
								d="M122,112 C135.317073,122.666667 147.682927,122.666667 161,112"
								id="Path-2"
								stroke="var(--nha-color-gray-400)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<path
								d="M114.5,52.5 L168,52.5"
								id="Line-Copy-3"
								stroke="var(--nha-color-gray-200)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<path
								d="M117.5,62.5 L165.023678,62.5"
								id="Line-Copy-4"
								stroke="var(--nha-color-gray-200)"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<ellipse
								id="Oval-Copy"
								fill="var(--nha-color-gray-200)"
								style="mix-blend-mode: multiply"
								cx="141"
								cy="173"
								rx="50"
								ry="3"
							></ellipse>
							<use
								id="Star"
								stroke-opacity="0.6"
								stroke="var(--nha-color-gray-400)"
								mask="url(#mask-2)"
								stroke-width="4"
								fill="var(--nha-color-yellow-200)"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-dasharray="4,1,12,2"
								transform="translate(146.500000, 14.500000) rotate(6.000000) translate(-146.500000, -14.500000) "
								xlink:href="#path-1"
							></use>
							<use
								id="Star-Copy"
								stroke-opacity="0.6"
								stroke="var(--nha-color-gray-400)"
								mask="url(#mask-4)"
								stroke-width="4"
								fill="var(--nha-color-yellow-200)"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-dasharray="4,1,12,2"
								transform="translate(209.000000, 28.000000) rotate(10.000000) translate(-209.000000, -28.000000) "
								xlink:href="#path-3"
							></use>
							<use
								id="Star-Copy-2"
								stroke-opacity="0.6"
								stroke="var(--nha-color-gray-400)"
								mask="url(#mask-6)"
								stroke-width="4"
								fill="var(--nha-color-yellow-200)"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-dasharray="4,1,12,2"
								transform="translate(74.000000, 35.000000) rotate(-10.000000) translate(-74.000000, -35.000000) "
								xlink:href="#path-5"
							></use>
						</g>
					</g>
				</g>
			</g>
		</svg>
		<div class="message">{{ message }}</div>
		<ng-content></ng-content>
	</div>
}
